import { createPlaceholderImages, createSample } from './model'
import type { SelectionMap } from './types'

export const BRACKET_EXAMPLE_EVENT = 'snapbracket:load-example'
export type BracketExampleId = 'pictures' | 'eight-team'

// 自创队名和图标，示例与下载模板共用同一份晋级数据。
export const EXAMPLE_TEAMS = [
  'Atlas',
  'Birch',
  'Cedar',
  'Dune',
  'Elm',
  'Fjord',
  'Grove',
  'Harbor',
]

export function createBracketExample(id: BracketExampleId) {
  return {
    participants: [...EXAMPLE_TEAMS],
    images: EXAMPLE_TEAMS.map((name) =>
      id === 'pictures' ? `/bracket-examples/${name.toLowerCase()}.svg` : null,
    ),
    selections: {
      0: { 0: 'home', 1: 'home', 2: 'home', 3: 'home' },
      1: { 0: 'home', 1: 'home' },
      2: { 0: 'home' },
    } as SelectionMap,
  }
}

export function hasBracketEdits({
  participants,
  images,
  selections,
  title,
  defaultTitle,
  teamCount,
  seedOrder,
}: {
  participants: string[]
  images: (string | null)[]
  selections: SelectionMap
  title: string
  defaultTitle: string
  teamCount: number
  seedOrder: number[] | null
}) {
  const names = createSample(8)
  const placeholders = createPlaceholderImages(8)
  return (
    teamCount !== 8 ||
    title !== defaultTitle ||
    seedOrder !== null ||
    Object.values(selections).some((round) => Object.keys(round).length > 0) ||
    participants.length !== 8 ||
    images.length !== 8 ||
    participants.some((name, index) => name !== names[index]) ||
    images.some((image, index) => image !== placeholders[index])
  )
}
